<template>
  <div class="cheetah-preview-file-overlay-fixed" :class="{'d-flex': show }">
    <div class="cheetah-preview-file-skin">
      <div class="cheetah-preview-file-outer">
        <div class="cheetah-preview-file-inner">
          <img :src="url" :alt="alt">
        </div>
      </div>
      <div class="cheetah-preview-file-title">{{ file.name }}</div>
      <a title="Close" class="cheetah-preview-file-item cheetah-preview-file-close" @click.prevent="close">
        <font-awesome-icon :icon="['fas', 'times']"/>
      </a>
    </div>
  </div>
</template>

<script>
    export default {
        name: "Preview",
        props: ['file', 'url', 'alt'],

        data(){
          return {
              show: false,
          }
        },

        methods: {
            open(){
                this.show = true;
                console.log('close');
            },

            close(){
                this.show = false;
                console.log('close');
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/general/FilesManager/Preview.vue